import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  SerializationStrategyh6ouydnm6hci as SerializationStrategy,
  KSerializerzf77vz1967fq as KSerializer,
} from '../KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { KClass1cc9rfeybg8hs as KClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KClassJs.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_EmptySerializersModuleLegacyJs() {
  _init_properties_SerializersModule_kt__u78ha3();
  return EmptySerializersModule;
}
var EmptySerializersModule;
var SerializersModuleClass;
function SerializersModule() {
  if (SerializersModuleClass === VOID) {
    class $ {
      x1o(kClass, typeArgumentsSerializers, $super) {
        typeArgumentsSerializers = typeArgumentsSerializers === VOID ? emptyList() : typeArgumentsSerializers;
        return $super === VOID ? this.y1o(kClass, typeArgumentsSerializers) : $super.y1o.call(this, kClass, typeArgumentsSerializers);
      }
    }
    initMetadataForClass($, 'SerializersModule');
    SerializersModuleClass = $;
  }
  return SerializersModuleClass;
}
var SerialModuleImplClass;
function SerialModuleImpl() {
  if (SerialModuleImplClass === VOID) {
    class $ extends SerializersModule() {
      constructor(class2ContextualFactory, polyBase2Serializers, polyBase2DefaultSerializerProvider, polyBase2NamedSerializers, polyBase2DefaultDeserializerProvider, hasInterfaceContextualSerializers) {
        super();
        this.t27_1 = class2ContextualFactory;
        this.u27_1 = polyBase2Serializers;
        this.v27_1 = polyBase2DefaultSerializerProvider;
        this.w27_1 = polyBase2NamedSerializers;
        this.x27_1 = polyBase2DefaultDeserializerProvider;
        this.y27_1 = hasInterfaceContextualSerializers;
      }
      w1o() {
        return this.y27_1;
      }
      d1t(baseClass, value) {
        if (!baseClass.ze(value))
          return null;
        var tmp0_safe_receiver = this.u27_1.u4(baseClass);
        var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u4(getKClassFromExpression(value));
        var registered = (!(tmp == null) ? isInterface(tmp, SerializationStrategy()) : false) ? tmp : null;
        if (!(registered == null))
          return registered;
        var tmp_0 = this.v27_1.u4(baseClass);
        var tmp1_safe_receiver = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
        return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(value);
      }
      c1t(baseClass, serializedClassName) {
        var tmp0_safe_receiver = this.w27_1.u4(baseClass);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.collections.get' call
          tmp = (isInterface(tmp0_safe_receiver, KtMap()) ? tmp0_safe_receiver : THROW_CCE()).u4(serializedClassName);
        }
        var tmp_0 = tmp;
        var registered = (!(tmp_0 == null) ? isInterface(tmp_0, KSerializer()) : false) ? tmp_0 : null;
        if (!(registered == null))
          return registered;
        var tmp_1 = this.x27_1.u4(baseClass);
        var tmp1_safe_receiver = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
        return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(serializedClassName);
      }
      y1o(kClass, typeArgumentsSerializers) {
        var tmp0_safe_receiver = this.t27_1.u4(kClass);
        var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z27(typeArgumentsSerializers);
        return (tmp == null ? true : isInterface(tmp, KSerializer())) ? tmp : null;
      }
      s27(collector) {
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = this.t27_1.l3().p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          // Inline function 'kotlin.collections.component1' call
          var kclass = element.m3();
          // Inline function 'kotlin.collections.component2' call
          var serial = element.n3();
          if (serial instanceof Argless()) {
            var tmp = isInterface(kclass, KClass()) ? kclass : THROW_CCE();
            var tmp_0 = serial.c28_1;
            collector.d28(tmp, isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE());
          } else {
            if (serial instanceof WithTypeArguments()) {
              collector.b28(kclass, serial.a28_1);
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s_0 = this.u27_1.l3().p1();
        while (_iterator__ex2g4s_0.q1()) {
          var element_0 = _iterator__ex2g4s_0.r1();
          // Inline function 'kotlin.collections.component1' call
          var baseClass = element_0.m3();
          // Inline function 'kotlin.collections.component2' call
          var classMap = element_0.n3();
          // Inline function 'kotlin.collections.forEach' call
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s_1 = classMap.l3().p1();
          while (_iterator__ex2g4s_1.q1()) {
            var element_1 = _iterator__ex2g4s_1.r1();
            // Inline function 'kotlin.collections.component1' call
            var actualClass = element_1.m3();
            // Inline function 'kotlin.collections.component2' call
            var serializer = element_1.n3();
            var tmp_1 = isInterface(baseClass, KClass()) ? baseClass : THROW_CCE();
            var tmp_2 = isInterface(actualClass, KClass()) ? actualClass : THROW_CCE();
            // Inline function 'kotlinx.serialization.internal.cast' call
            var tmp$ret$15 = isInterface(serializer, KSerializer()) ? serializer : THROW_CCE();
            collector.e28(tmp_1, tmp_2, tmp$ret$15);
          }
        }
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s_2 = this.v27_1.l3().p1();
        while (_iterator__ex2g4s_2.q1()) {
          var element_2 = _iterator__ex2g4s_2.r1();
          // Inline function 'kotlin.collections.component1' call
          var baseClass_0 = element_2.m3();
          // Inline function 'kotlin.collections.component2' call
          var provider = element_2.n3();
          var tmp_3 = isInterface(baseClass_0, KClass()) ? baseClass_0 : THROW_CCE();
          collector.f28(tmp_3, typeof provider === 'function' ? provider : THROW_CCE());
        }
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s_3 = this.x27_1.l3().p1();
        while (_iterator__ex2g4s_3.q1()) {
          var element_3 = _iterator__ex2g4s_3.r1();
          // Inline function 'kotlin.collections.component1' call
          var baseClass_1 = element_3.m3();
          // Inline function 'kotlin.collections.component2' call
          var provider_0 = element_3.n3();
          var tmp_4 = isInterface(baseClass_1, KClass()) ? baseClass_1 : THROW_CCE();
          collector.g28(tmp_4, typeof provider_0 === 'function' ? provider_0 : THROW_CCE());
        }
      }
    }
    initMetadataForClass($, 'SerialModuleImpl');
    SerialModuleImplClass = $;
  }
  return SerialModuleImplClass;
}
var ArglessClass;
function Argless() {
  if (ArglessClass === VOID) {
    class $ extends ContextualProvider() {}
    initMetadataForClass($, 'Argless');
    ArglessClass = $;
  }
  return ArglessClass;
}
var WithTypeArgumentsClass;
function WithTypeArguments() {
  if (WithTypeArgumentsClass === VOID) {
    class $ extends ContextualProvider() {}
    initMetadataForClass($, 'WithTypeArguments');
    WithTypeArgumentsClass = $;
  }
  return WithTypeArgumentsClass;
}
var ContextualProviderClass;
function ContextualProvider() {
  if (ContextualProviderClass === VOID) {
    class $ {}
    initMetadataForClass($, 'ContextualProvider');
    ContextualProviderClass = $;
  }
  return ContextualProviderClass;
}
var properties_initialized_SerializersModule_kt_fjigjn;
function _init_properties_SerializersModule_kt__u78ha3() {
  if (!properties_initialized_SerializersModule_kt_fjigjn) {
    properties_initialized_SerializersModule_kt_fjigjn = true;
    EmptySerializersModule = new (SerialModuleImpl())(emptyMap(), emptyMap(), emptyMap(), emptyMap(), emptyMap(), false);
  }
}
//region block: exports
export {
  get_EmptySerializersModuleLegacyJs as get_EmptySerializersModuleLegacyJs2imgse4bg8t49,
};
//endregion

//# sourceMappingURL=SerializersModule.mjs.map
